import { seoKeywords } from '../home/Home.seo';

export const blogSeo = {
  title: 'Rumble Fish | Blog',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Get the latest technology insights on our blog! Discover more about topics such as custom software development, cryptocurrency, FinTech trends, Blockchain applications, IT outsourcing, best software development practices, web development, mobile app development.',
    },
  ],
};
